<template>
  <div class="modal fade" id="editAccountUserModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit User</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateUser">
            <h5>{{ userName }}</h5>
            <div class="form-group">
              <label for="organization">Organization</label>
              <select
                class="form-control"
                id="organization"
                v-model="newUserOrganization"
                required
              >
                <option value="" selected disabled>Select Organization</option>
                <option
                  v-for="org in Organizations"
                  :key="org.Organization_Id"
                  v-bind:value="org.Organization_Id"
                  >{{ org.Name }}</option
                >
              </select>
            </div>
            <div class="form-group">
              <label for="permission">Permission Group</label>
              <select
                class="form-control"
                id="permission"
                v-model="newUserPermissionsGroup"
                required
              >
                <option value="null" selected disabled
                  >Select Permissions</option
                >
                <option
                  v-for="group in permissionGroups"
                  :key="group.description"
                  v-bind:value="group"
                >
                  {{ group.description }}
                </option>
              </select>
              <small
                v-if="newUserPermissionsGroup != null"
                class="text-secondar"
                >{{ newUserPermissionsGroup.info }}</small
              >
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                Update User
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { permissionGroups } from "@/constants/PermissionGroups";

export default {
  name: "CreateUserModal",
  data() {
    return {
      userName: "",
      newUserOrganization: null,
      newUserPermissionsGroup: null,
      permissionGroups: permissionGroups
    };
  },
  props: {
    UserToEdit: Object,
    Organizations: Array
  },
  watch: {
    UserToEdit: function() {
      this.userName =
        this.UserToEdit.First_Name + " " + this.UserToEdit.Last_Name;
      this.newUserOrganization = this.UserToEdit.Organization_Id;
      this.newUserPermissionsGroup = this.getApplicablePermissionGroup(
        this.UserToEdit.Permissions
      );
      this.permissionGroups =
        this.UserToEdit.Account_Id == 1
          ? permissionGroups
          : permissionGroups.filter(p => p.fundsGranted == false);
    }
  },
  mounted() {},
  methods: {
    getApplicablePermissionGroup(userPermissions) {
      var userPerm = userPermissions
        .map(p => p.Permission.Permission_Id)
        .sort((a, b) => a - b);
      var groupToReturn = null;
      for (let i = 0; i < this.permissionGroups.length; i++) {
        if (this.permissionGroups[i].value.toString() == userPerm.toString()) {
          groupToReturn = this.permissionGroups[i];
          break;
        }
      }
      return groupToReturn;
    },
    async updateUser() {
      var view = this;
      view.$store.commit("updateLoading", true);
      $("#editAccountUserModal").modal("hide");
      var user = this.UserToEdit;
      user.Organization_Id = view.newUserOrganization;
      user.Organization = view.Organizations.find(
        o => o.Organization_Id == view.newUserOrganization
      );
      await this.$updateUserOrganization(
        view.UserToEdit.User_Id,
        view.newUserOrganization
      )
        .then(async () => {
          await view.savePermissions().then(newPermissions => {
            user.Permissions = newPermissions;
            if (user.User_Id == view.$store.getters.user.User_Id) {
              view.$store.getters.user.Organization_Id =
                view.newUserOrganization;
              view.$store.getters.user.Permissions = newPermissions;
            }
            view.$emit("editedUser", user);
            view.$store.commit("updateLoading", false);
          });
        })
        .catch(err => {
          console.log(err);
          view.$store.commit("updateLoading", false);
          $("#editAccountUserModal").modal("show");
        });
    },
    async savePermissions() {
      var view = this;
      view.$store.commit("updateLoading", true);
      var currentPermissions = view.getUserCurrentPermissions(view.UserToEdit);
      var addedPermissions = view.newUserPermissionsGroup.value.filter(
        p =>
          !currentPermissions.some(c => {
            return (
              p == c.Permission && view.newUserOrganization == c.Organization
            );
          })
      );
      addedPermissions = addedPermissions.map(p => {
        var permission = {};
        permission.User_Id = parseInt(view.UserToEdit.User_Id);
        permission.Permission_Id = parseInt(p);
        permission.Organization_Id = parseInt(view.newUserOrganization);
        return permission;
      });
      var removedPermissions = view.UserToEdit.Permissions.filter(
        c =>
          !view.newUserPermissionsGroup.value.some(p => {
            return (
              p == c.Permission.Permission_Id &&
              view.newUserOrganization == c.Organization.Organization_Id
            );
          })
      );
      try {
        return await view
          .$addPermissions(addedPermissions, parseInt(view.UserToEdit.User_Id))
          .then(async () => {
            return await view
              .$removePermissions(
                removedPermissions.map(p => parseInt(p.UserPermission_Id)),
                parseInt(view.UserToEdit.User_Id)
              )
              .then(permissions => {
                return permissions;
              });
          });
      } catch (err) {
        console.log(err);
      }
    },
    getUserCurrentPermissions(user) {
      return user.Permissions.map(p => {
        var permission = {};
        permission.Organization = p.Organization.Organization_Id;
        permission.Permission = p.Permission.Permission_Id;
        return permission;
      });
    }
  }
};
</script>
